import { render, staticRenderFns } from "./medkon_tier_source.vue?vue&type=template&id=2c12ddc9"
import script from "./medkon_tier_source.vue?vue&type=script&lang=js"
export * from "./medkon_tier_source.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports